/**
 * Image CrossFrame Listeners
 *
 * Handles CrossFrame requests for IRIS image operations.
 * Validates required parameters and delegates to the gateway client via getServiceClient().
 */

// Ensure all IRIS model types (including OnShelfProductCropMetadata) are registered
// in modelRegistrySingleton before Coral attempts to deserialize the getCropSets response.
import '@amzn/coral_com-amazon-ihmirisservice-model/index'

import { getServiceClient } from '@api/client-factory/StoreManagementClientFactory'
import { GetCropSetsInput } from '@amzn/coral_com-amazon-ihmirisservice-model/GetCropSetsInput'
import { GetCropSetsOutput } from '@amzn/coral_com-amazon-ihmirisservice-model/GetCropSetsOutput'
import { validateRequired } from './listenerUtils'

export async function getCropSetsListener (message: any): Promise<GetCropSetsOutput> {
    const params = (message && message.data) || {}
    validateRequired(params, 'storeId')
    const client = getServiceClient()
    return client.getCropSets(GetCropSetsInput.clone(params)).toPromise()
}
